import { Box } from '@mui/material';
import React from 'react';

export const MyMDragAndDrop = (props) => {
  const { onDrop, ...other } = props;
  const handleDragOver = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };
  const handleDrop = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onDrop(e);
  };
  return (
    <Box onDragOver={handleDragOver} onDrop={handleDrop} sx={{ display: "inline-block" }} {...other}>
      {props.children}
    </Box>
  );

}